<template>
  <div>
    <GenericPage>
      <template slot="breadcrumb-items">
        <li class="active bold">Contrato de Comisión Mercantil.</li>
      </template>
      <template slot="title">
        Contrato de Comisión Mercantil Instalador.
      </template>
      <template slot="body">
        <SupplierMerchantContract />
      </template>
    </GenericPage>
  </div>
</template>

<script>
import GenericPage from "./new-portal-views/GenericPage.vue";
import SupplierMerchantContract from "@components/contracts/SupplierMerchantContract";
export default {
  name: "SupplierMerchantContractPage",
  components: {SupplierMerchantContract, GenericPage}
}
</script>

<style scoped>

</style>